module.exports = __webpack_public_path__ + "static/media/Graphic15.78e87702.png";